import { render, staticRenderFns } from "./ForestsView.vue?vue&type=template&id=62dc0543&"
import script from "./ForestsView.vue?vue&type=script&lang=js&"
export * from "./ForestsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports